import dynamic from "next/dynamic";

export const TrustBoxWrapper = dynamic(() => import("./TrustBox"), {
  ssr: false,
});
